<template>
    <div
        :id="'widgetDebug' + widgetId"
        class="vue-widget-debug"
        :class="{ 'vue-widget-debug-error': inError }"
    >
        <span
            >{{ widgetId }}: {{ platformState }} | {{ currentState }} |
            {{ displayCurrentState }} | {{ settingsCurrentState }}</span
        >
        <ul v-if="hasDebugMessages">
            <li v-for="d in debugMessages" :key="d">
                {{ d }}
            </li>
        </ul>
    </div>
</template>

<script>
import * as WidgetStates from "../../constants/widgetStates";
import { horizonService } from "../../stateMachines/horizonStateMachine";

export default {
    name: "WidgetDebug",
    props: {
        widgetId: {
            type: Number,
            required: true,
        },
    },
    computed: {
        platformState() {
            return horizonService.currentState;
        },
        currentState() {
            return horizonService.context.widgets[this.widgetId]._state.value;
        },
        displayCurrentState() {
            return horizonService.context.widgets[this.widgetId]._state.context
                .displayMachine.state.value;
        },
        settingsCurrentState() {
            return horizonService.context.widgets[this.widgetId]._state.context
                .settingsMachine.state.value;
        },
        inError() {
            return this.currentState === WidgetStates.ERRORED;
        },
        debugMessages() {
            return horizonService.context.widgets[this.widgetId]._state.context
                .debugMessages;
        },
        hasDebugMessages() {
            return this.debugMessages.size > 0;
        },
    },
};
</script>

<style lang="scss" scoped>
.vue-widget-debug {
    background-color: var(--v2-debug-background);
    color: var(--v2-debug-text);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-bottom: 0px;
    padding: 2px;
    text-align: left;
    span {
        font-size: 8pt;
        font-weight: bold;
        padding-left: 2px;
        padding-right: 0px;
    }
}

.vue-widget-debug-error {
    background-color: var(--vue-widget-error-lowlight);
}
</style>
